import React from 'react';

interface ManagerDashboardTileContentProps {
  onPress?: () => void;
}

/**
 * ManagerDashboardTileContent - A widget component that displays a message for managers
 * to review or approve hours. The component is clickable and can trigger an action when clicked.
 */
const ManagerDashboardTileContent: React.FC<ManagerDashboardTileContentProps> = ({ onPress }) => {
  return (
    <div 
      className="bg-white w-full"
      onClick={onPress}
    >
      <div className="flex items-start">
        <p className="text-base text-gray-500">
          Tap to review or approve hours
        </p>
      </div>
    </div>
  );
};

export default ManagerDashboardTileContent;